import { render } from "./Unauthenticated.vue?vue&type=template&id=4b1396c6&scoped=true"
import script from "./Unauthenticated.vue?vue&type=script&lang=js"
export * from "./Unauthenticated.vue?vue&type=script&lang=js"

import "./Unauthenticated.vue?vue&type=style&index=0&id=4b1396c6&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1396c6"]])

export default __exports__